import React from 'react';
import Relay from 'react-relay';

import RelayStore from '../../RelayStore'
import ChatPanel from '../../components/ChatPanel'


class EditChat extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { viewer, router } = this.props;
    const { chat } = viewer;
    if (!chat) return (<div>loading chat...</div>)

    return (
			<div className="panel" style={{marginTop:20}}>
		    {this.props.viewer && this.props.viewer.chat &&
          <ChatPanel
            viewer={this.props.viewer}
            chat={chat}
          />
        }
			</div>
    );
  }

}

export default Relay.createContainer(EditChat, {
  initialVariables: {
    chatId: null,
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        chat (id: $chatId) {
          ${ChatPanel.getFragment('chat')}
        }
      }
      `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Chats/EditChat.js